import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InscriptionsService } from '../inscriptions.service';
import { ResultMessageType } from '../../error/error.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inscription-cancel',
  templateUrl: './inscription-cancel.component.html'
})
export class InscriptionCancelComponent implements OnInit {

  state: 'loading' | 'redirecting' = 'loading';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inscriptionsService: InscriptionsService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    const communityCode = this.route.snapshot.paramMap.get('community');
    const inscriptionSentUuid = this.route.snapshot.paramMap.get('inscriptionSentUuid');

    if (!communityCode || !inscriptionSentUuid) {
      this.goToResult(
        ResultMessageType.Error,
        this.translate.instant('INSCRIPTIONS.CancelInMail.ErrorTitle'),
        this.translate.instant('ERROR.IncorrectURL'),
      );
      return;
    }

    this.inscriptionsService.cancelInscription(communityCode, inscriptionSentUuid).subscribe({
      next: () => {
        this.goToResult(
          ResultMessageType.Success,
          this.translate.instant('INSCRIPTIONS.CancelInMail.SuccessTitle'),
          this.translate.instant('INSCRIPTIONS.CancelInMail.SuccessText'),
        );
      },
      error: (err) => {
        const errorCode = err?.error;

        if (errorCode === 'INSCRIPTION_ALREADY_CANCELLED') {
          this.goToResult(
            ResultMessageType.Success,
            this.translate.instant('INSCRIPTIONS.CancelInMail.AlreadyCancelledTitle'),
            this.translate.instant('INSCRIPTIONS.CancelInMail.AlreadyCancelledText'),
          );
          return;
        }

        this.goToResult(
          ResultMessageType.Error,
          this.translate.instant('INSCRIPTIONS.CancelInMail.ErrorTitle'),
          this.translate.instant('INSCRIPTIONS.CancelInMail.ErrorText'),
        );
      }
    });
  }

  private goToResult(type: ResultMessageType, title: string, message: string) {
    this.state = 'redirecting';
    this.router.navigate(['/success'], {
      state: {
        type,
        title,
        message
      }
    });
  }
}

